import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SmartsuppComponent} from '@app/modules/shared/components/smartsupp/smartsupp.component';
import {StickerButtonComponent} from '@app/modules/shared/components/sticker-button/sticker-button.component';
import {
  StudentsFullScreenMaskComponent
} from '@app/modules/shared/components/students-fullscrean-mask/students-full-screen-mask.component';
import {UserActionPanelComponent} from '@app/modules/shared/components/user-action-panel/user-action-panel.component';
import {SecondsToTimerValuePipe} from '@app/modules/shared/pipes/seconds-to-timer-value.pipe';
import {NgbPopoverModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {FormsModule} from '@angular/forms';
import {GameModeComponent} from '@app/modules/shared/components/game-mode/game-mode.component';
import {
  TeamInfoControlComponent
} from '@app/modules/shared/components/dialogs/team-info-control/team-info-control.component';
import {
  MediaDeviceConfigurationComponent
} from '@app/modules/shared/components/dialogs/media-device-configuration/media-device-configuration.component';
import {
  MuteSelfAudioConfigurationComponent
} from '@app/modules/shared/components/dialogs/mute-self-audio-configuration/mute-self-audio-configuration.component';
import {ClassroomClosedComponent} from '@app/modules/shared/components/classroom-closed/classroom-closed.component';
import {CustomColorPickerComponent} from './components/dialogs/custom-color-picker/custom-color-picker.component';
import {ColorPickerModule} from '@iplab/ngx-color-picker';
import { LoaderComponent } from './components/loader/loader.component';
import {InfoComponent} from '@app/modules/shared/components/info/info.component';
import {
  ChangeTeacherNicknameComponent
} from '@app/modules/shared/components/dialogs/change-teacher-nickname/change-teacher-nickname.component';
import {JsonLogService} from '@app/modules/shared/services/json-log.service';
import {IsStaffPipe} from '@app/modules/shared/pipes/is-staff.pipe';
import {IsMessageFromPipe} from '@app/modules/shared/pipes/is-message-from.pipe';
import { TeamNamePipe } from './pipes/team-name.pipe';
import { AvailableStudentsForTeamPipe } from './pipes/available-students-for-team.pipe';
import { IsInLastRowPipe } from './pipes/is-in-last-row.pipe';
import { IsSharedWithPipe } from './pipes/is-shared-with.pipe';
import {FullNamePipe} from '@app/modules/shared/pipes/full-name.pipe';
import {IsSharedPipe} from '@app/modules/shared/pipes/is-shared.pipe';
import {ErrorDialogComponent} from '@app/modules/shared/components/dialogs/error-dialog/error-dialog.component';
import {WhiteboardLoaderComponent} from '@app/modules/shared/components/whiteboard-loader/whiteboard-loader.component';
import { ReconnectionErrorComponent } from './components/dialogs/reconnection-error/reconnection-error.component';
import {UnansweredMessagesPipe} from '@app/modules/shared/pipes/unanswered-messages.pipe';
import { IsTeacherPipe } from './pipes/is-teacher.pipe';
import { IsSupportPipe } from './pipes/is-support.pipe';
import { IsObserverPipe } from './pipes/is-observer.pipe';
import { UserByIdPipe } from './pipes/user-by-id.pipe';
import { IsSupportOrObserverPipe } from './pipes/is-support-or-observer.pipe';
import { IsStudentPipe } from './pipes/is-student.pipe';
import { CanEnterPrivateTalkPipe } from './pipes/can-enter-private-talk.pipe';
import { SessionEndedComponent } from './components/session-ended/session-ended.component';
import { EncodeUriComponentPipe } from './pipes/encode-uri-component.pipe';


@NgModule({
  declarations: [
    SmartsuppComponent,
    StickerButtonComponent,
    StudentsFullScreenMaskComponent,
    UserActionPanelComponent,
    TeamInfoControlComponent,
    ChangeTeacherNicknameComponent,
    MediaDeviceConfigurationComponent,
    MuteSelfAudioConfigurationComponent,
    GameModeComponent,
    ClassroomClosedComponent,
    SecondsToTimerValuePipe,
    CustomColorPickerComponent,
    ErrorDialogComponent,
    LoaderComponent,
    WhiteboardLoaderComponent,
    InfoComponent,
    FullNamePipe,
    IsMessageFromPipe,
    IsStaffPipe,
    TeamNamePipe,
    AvailableStudentsForTeamPipe,
    IsInLastRowPipe,
    IsSharedWithPipe,
    IsSharedPipe,
    UnansweredMessagesPipe,
    ReconnectionErrorComponent,
    IsTeacherPipe,
    IsSupportPipe,
    IsObserverPipe,
    UserByIdPipe,
    IsSupportOrObserverPipe,
    IsStudentPipe,
    ReconnectionErrorComponent,
    CanEnterPrivateTalkPipe,
    ReconnectionErrorComponent,
    SessionEndedComponent,
    EncodeUriComponentPipe
  ],
  exports: [
    SmartsuppComponent,
    StickerButtonComponent,
    StudentsFullScreenMaskComponent,
    UserActionPanelComponent,
    TeamInfoControlComponent,
    ChangeTeacherNicknameComponent,
    MediaDeviceConfigurationComponent,
    MuteSelfAudioConfigurationComponent,
    GameModeComponent,
    ClassroomClosedComponent,
    SecondsToTimerValuePipe,
    CustomColorPickerComponent,
    ErrorDialogComponent,
    LoaderComponent,
    WhiteboardLoaderComponent,
    InfoComponent,
    FullNamePipe,
    IsMessageFromPipe,
    IsStaffPipe,
    IsSharedWithPipe,
    IsSharedPipe,
    UnansweredMessagesPipe,
    IsTeacherPipe,
    UserByIdPipe,
    IsSupportPipe,
    IsSupportOrObserverPipe,
    IsStudentPipe,
    IsSharedPipe,
    CanEnterPrivateTalkPipe,
    EncodeUriComponentPipe
  ],
  imports: [
      CommonModule,
      NgbPopoverModule,
      BsDropdownModule,
      FormsModule,
      ColorPickerModule,
      NgbTooltipModule
  ],
  providers: [
    JsonLogService
  ]
})
export class SharedModule { }
